<script setup lang="ts">
import AuthService from '../services/Auth/AuthService'

interface Props {
  redirect?: string
}

const props = defineProps<Props>()
AuthService.authorize(props.redirect ?? null)
</script>

<template>
  <div></div>
</template>
